















































































































import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import { Validations } from 'vuelidate-property-decorators';
import vSelect from 'vue-select';
import { required } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { OrgsApi, Product, ProductsApi } from '../../../../api';
import Toast from '@/components/display/toast.vue';
import SitePicker from '@/components/site-picker.vue';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import { AxiosResponse } from 'axios';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
@Component({
	components: {
		SaveCancelButtons,
		secondaryNav,
		vSelect,
		SitePicker,
	},
})
export default class ProductUpdate extends mixins(validationMixin) {
	public form = {
		fonterraCaseId: '',
		site: {},
		supplierNumber: {},
		supplier: '',
		farmSourceRegion: '',
	};

	public milkCompanies: Array<{ value: string; text: string; orgId: number }> = [];

	public fssOptions = [
		{ value: 'Bay of Plenty', text: 'Bay of Plenty' },
		{ value: 'Canterbury', text: 'Canterbury' },
		{ value: 'Central Districts', text: 'Central Districts' },
		{ value: 'Northland', text: 'Northland' },
		{ value: 'Southland and Otago', text: 'Southland and Otago' },
		{ value: 'Taranaki', text: 'Taranaki' },
		{ value: 'Waikato', text: 'Waikato' },
	];

	public product: Product | null = null;

	public $bvToast: any;
	public loading = true;
	public isOnNewOrdwayPlan: boolean | null = null;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;

	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
	}

	@Validations()
	public validations() {
		return {
			form: {
				fonterraCaseId: {},
				site: { required },
				supplierNumber: {},
			},
		};
	}

	public async getPartnerOrgsByProductType() {
		try {
			const response = await new OrgsApi().orgGetPartnersByProductType('milk');
			this.milkCompanies = response.data.data.map(supplier => {
				return { text: supplier.name, value: supplier.supplierCode, orgId: supplier.id };
			});
		} catch (e) {
			console.log(e);
		}
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const { productId } = this.$route.params;
		const product: Product = this.product;
		product.fonterraCaseId = this.form.fonterraCaseId;
		product.siteId = this.form.site.id;
		product.supplierNumber = this.form.supplierNumber;
		product.supplier = this.form.supplier;
		product.fssRegion = this.form.farmSourceRegion;
		product.notes = this.form.notes;
		let productResponse: AxiosResponse<any>; // This is actually a product - typed as void from api!?
		try {
			productResponse = await new ProductsApi().updateProduct(parseInt(productId, 10), {
				data: product,
			});
		} catch (e) {
			const error = e.response.data.errors;
			new Toast().makeToast(error, 'Error Updating Product', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Product Updated', 'Successfully', 'success');

		setTimeout(() => {
			this.submitStatus = 'OK';
			this.$router.push({ name: 'products.milk.view', params: { productId } });
		}, 1000);
	}

	public async load() {
		const { productId } = this.$route.params;
		this.submitStatus = 'OK';
		this.loading = true;

		try {
			const response = await this.api.getProductById(parseInt(productId, 10), {
				params: { include: 'org,site,subscriptionitem' },
			});
			const product: Product = response.data;
			this.form.fonterraCaseId = product.fonterraCaseId;
			this.form.supplierNumber = product.supplierNumber;
			this.form.farmSourceRegion = product.fssRegion;
			this.form.supplier = product.supplier;
			this.form.status = product.status;
			this.form.notes = product.notes;
			// console.log(product.subscriptionitem);

			this.form.site = product.site;

			this.product = product;
		} catch (e) {
			this.product = null;
		}
	}

	public async created() {
		await this.load();
		await this.getPartnerOrgsByProductType();
		this.loading = false;
	}
}
